import { LayoutModule } from '../../../../layout/modules';
import PersonIcon from '@mui/icons-material/Person';
import { PqrRegisterHistory } from './registerHistory';
import { usePqrDetail } from './hook';
import { PqrDetailActions } from './actions';
import { PqrAccountInfo } from './accountInfo';
import { PqrSmartHistory } from './smartHistory';
import { PqrDetailGeneralInfo } from './generalInfo';
import { PqrStatusHistory } from './statusHistory';
import { PqrAttachment } from './attachments';
import { PqrDataInfo } from './dataInfo';
import { PqrDataInitialCausality } from './initialCausality';
import { PqrNotificationClient } from './notificationClient';
import { PqrInfo } from './info';
import { PqrReconsideration } from './reconsideration';
import { PqrProductData } from './productData';
import { PqrStrategicAlly } from './strategicAlly';
import { PqrResponseMedium } from './responseMedium';
import { PqrObservationClose } from './closing/observationClose';
import { PqrComplianceTerms } from './closing/complianceTerms';
import { PqrNonComplianceReason } from './closing/nonComplianceReason';
import { PqrCompensation } from './closing/compensation';
import { PqrInFavorOf } from './inFavorOf';
import { PqrFinalCausality } from './protection';
import { PqrRedirect } from './redirect';
import { PqrDatesInfo } from './datesInfo';
import { PqrDataSfc } from './dataSfc';
import { PqrDetailProps } from './props';
import { ISelect } from '../../../../../shared/types/shared';
import { PqrSurveyDetail } from './survey';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ACCOUNTS_DETAIL } from '../../../../../routes/paths';
import { PqrSample } from './closing/sample';
import { PqrNotificationClose } from './closing/notificacionDfc';
import { isTrainerOrQuality } from '../../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { PqrDataFinalCausality } from './finalCausality';

export const PqrDetail = ({ samples }: PqrDetailProps) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { pqr, loading } = usePqrDetail();

    const additionalButtons = !isTrainerOrQuality(type) ? (
        <PqrDetailActions pqr={pqr} samples={samples} />
    ) : undefined;

    return (
        <>
            <LayoutModule
                title="Detalle caso PQR"
                titleChildren="Detalle cuenta"
                titleRigthChildren={
                    <a
                        href={`${ACCOUNTS_DETAIL}/${pqr?.account?.id}`}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <OpenInNewIcon sx={{ color: 'primary.main' }} />
                    </a>
                }
                icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                additionalButtons={additionalButtons}
            >
                <PqrAccountInfo account={pqr?.account} loading={loading} />
            </LayoutModule>
            <PqrDetailGeneralInfo pqr={pqr} />
            <PqrRegisterHistory pqr={pqr} />
            <PqrDataInfo dataInfo={pqr?.data || undefined} />
            <PqrDataInitialCausality
                initialCausality={pqr?.initialCausality || undefined}
            />
            <PqrNotificationClient
                notificationClient={pqr?.notificationClients || undefined}
            />
            <PqrDataSfc
                status={pqr?.info?.status as ISelect}
                dataSfc={pqr?.dataSfc || undefined}
                hasReconsideration={pqr?.reconsideration?.hasReconsideration}
                gender={(pqr?.account?.gender as ISelect)?.name}
                isLGBTIQ={pqr?.account?.isLGBTIQ}
                half={(pqr?.data?.half as ISelect)?.name || undefined}
                dataReconsideration={pqr?.reconsideration || undefined}
            />
            <PqrInfo info={pqr?.info || undefined} />
            <PqrReconsideration
                reconsideration={pqr?.reconsideration || undefined}
            />
            <PqrProductData productData={pqr?.productData || undefined} />
            <PqrStrategicAlly strategicAlly={pqr?.strategicAlly || undefined} />
            <PqrDatesInfo
                datesInfo={pqr?.statusManagement || undefined}
                createdAt={pqr?.created_at}
            />
            <PqrRedirect redirect={pqr?.redirect || undefined} />
            <PqrInFavorOf inFavorOf={pqr?.inFavorOf || undefined} />
            <PqrDataFinalCausality
                finalCausality={pqr?.finalCausality || undefined}
            />
            <PqrFinalCausality
                finalCausality={pqr?.finalCausality || undefined}
            />
            <PqrResponseMedium
                responseMedium={pqr?.responseMedium || undefined}
            />
            <PqrObservationClose closing={pqr?.closing || undefined} />
            <PqrNotificationClose closing={pqr?.closing || undefined} />
            <PqrSample closing={pqr?.closing || undefined} />
            <PqrComplianceTerms closing={pqr?.closing || undefined} />
            <PqrNonComplianceReason closing={pqr?.closing || undefined} />
            <PqrCompensation closing={pqr?.closing || undefined} />
            <PqrStatusHistory pqrId={pqr?.id || ''} />
            <PqrAttachment attachment={pqr?.attachmentsFinally || []} />
            <PqrSmartHistory pqrId={pqr?.id || ''} />
            {pqr?.survey && (
                <PqrSurveyDetail
                    pqrSurvey={pqr?.survey}
                    halfName={(pqr.data?.half as ISelect).name}
                />
            )}
        </>
    );
};
